export function show_hours(value, hours) {
  return hours.find(h => h.id === value)?.text || '-'
}
